import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ICreateSharedListPayload {
    data: {
        matchList: string
        sharedWithCompanies: any
        emailContent: string
    }
    sagaCB?: {
        onSuccess: any
    }
}

export interface ICreateSharedListState {
    status: string
    data: any
    errors: any
}

const initialState: ICreateSharedListState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const createSharedList = createSlice({
    name: 'sharedList/create',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<ICreateSharedListPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const createSharedListActions = createSharedList.actions
export default createSharedList.reducer
